let state = {
  auth: {},
  shopList: [],
  user: 0
}

const mutations = {
  pushshopList(state, arr) {
    state.shopList = arr
  },
  user(state, obj) {
    state.user = obj
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions: {},
  getters
}
